export default __webpack_public_path__ + "static/media/maps.a033c112.svg";